$(document).ready(function () {
  console.log('Ready....!');
  // Custom Color
  $('.color-swatch').each(function(){
    let color = $(this).data('value');
    if(color == 'Silver'){
      $(this).css('background-image', 'url(https://cdn.shopify.com/s/files/1/0644/7238/3733/files/silver_b20caed5-1295-4de3-8b96-d8c1ea20775a.png?v=1678669873)');
      $(this).attr('data-color', 'Silver');
    }
    if(color == 'Gold'){
      $(this).css('background-image', 'url(https://cdn.shopify.com/s/files/1/0644/7238/3733/files/gold_70d0c73b-4df6-4159-bbd6-22b1b4174993.png?v=1678669872)');
      $(this).attr('data-color', 'Gold');
    }
    if(color == 'RoseGold'){
      $(this).css('background-image', 'url(https://cdn.shopify.com/s/files/1/0644/7238/3733/files/rosegold_c00df9c4-1792-46db-b6f1-d5cc282c850a.png?v=1678669872)');
      $(this).attr('data-color', '#f8ccc0');
    }
  });
  //


  
  // Apply Preview Images by Default
  let counter = 0;
  const excludedCollections = ["rose-gold-jewellery", "gold-jewellery", "silver-jewellery", "gift-cards"];
if (!excludedCollections.includes(document.body.id)) {
    setTimeout(function() {
      applyPreviewImages();
    }, 200);
  }

   // Apply Preview Images by Default
  if (!excludedCollections.includes(document.body.id)) {
    setTimeout(function() {
      applyPreviewImages();
    }, 5000);
  }

    if (!excludedCollections.includes(document.body.id)) {
    setTimeout(function() {
      applyPreviewImages();
    }, 10000);
  }

      if (!excludedCollections.includes(document.body.id)) {
    setTimeout(function() {
      applyPreviewImages();
    }, 20000);
  }
  
  
  // Apply Preview Images by Default
  /*let counter = 0;
  setTimeout(function() {
    applyPreviewImages();
  }, 200);*/
  
  // Apply Preview Images on Scroll
  /*$(window).scroll(function() {
    if ($(window).scrollTop() == $(document).height() - $(window).height()) {
      applyPreviewImages();
    }
  });*/
  /*$(window).scroll(function() {
  let scrollTop = $(window).scrollTop();
  if (scrollTop % 100 == 0) {
    applyPreviewImages();
  }
  });*/
let quarterHeight = $(window).height() / 1;

$(window).scroll(function() {
  if (!excludedCollections.includes(document.body.id)) {
    let scrollTop = $(window).scrollTop();
    if (scrollTop % quarterHeight < 5) { // add a small margin of error to account for rounding issues
      applyPreviewImages();
    }
  }
});

  function applyPreviewImages() {
  $('.product-item').each(function() {
    // check if the product item has more than one color-swatch element
    if ($(this).find('.color-swatch').length > 2) {
      let silver = $(this).find('.color-swatch[data-value="Silver"]').data('image');
      let gold = $(this).find('.color-swatch[data-value="Gold"]').data('image');
      let roseGold = $(this).find('.color-swatch[data-value="RoseGold"]').data('image');
      let previewImages = [silver, gold, roseGold];
      let previewImage = previewImages[counter % 3];
      $(this).find('.product-item__bg').attr("data-image", previewImage);
      $(this).find('.product-item__bg').css({"background-image": "url(" + previewImage + ")"});
      $(this).find('.product-item__bg__under').attr("data-image", previewImage);
      $(this).find('.product-item__bg__under').css({"background-image": "url(" + previewImage + ")"});
      counter++;
    }
  });
}
  
  /*OLD CODE (PRE effect only data value)
  function applyPreviewImages() {
    $('.product-item').each(function(){
      let silver = $(this).find('.color-swatch[data-value="Silver"]').data('image');
      let gold = $(this).find('.color-swatch[data-value="Gold"]').data('image');
      let roseGold = $(this).find('.color-swatch[data-value="RoseGold"]').data('image');
      let previewImages = [silver, gold, roseGold];
      let previewImage = previewImages[counter % 3];
      $(this).find('.product-item__bg').attr("data-image",previewImage);
      $(this).find('.product-item__bg').css({"background-image": "url(" + previewImage + ")"}) ;
      $(this).find('.product-item__bg__under').attr("data-image",previewImage);
      $(this).find('.product-item__bg__under').css({"background-image": "url(" + previewImage + ")"}) ;
      counter++;
    });
  }
  */
  // Hover Effect
  $('.color-swatch').click(function(){
      let img = $(this).data('image');
      let url = $(this).data('url');
      $(this).closest(".product-item").find('.product-item__bg').attr("data-image",img);
      $(this).closest(".product-item").find('.product-item__bg').css({"background-image": "url(" + img + ")"}) ;
      $(this).closest(".product-item").find('.product-item__bg__under').attr("data-image",img);
      $(this).closest(".product-item").find('.product-item__bg__under').css({"background-image": "url(" + img + ")"}) ;
      $(this).closest(".product-item").find('[data-varient-url]').attr("href",url);
      console.log('Image', img,url);
  });
});

/*$(document).ready(function () {
  console.log('Ready....!');
    // Apply Preview Images by Default
  let counter = 0;
  setTimeout(function() {
    $('.product-item').each(function(){
      let silver = $(this).find('.color-swatch[data-value="Silver"]').data('image');
      let gold = $(this).find('.color-swatch[data-value="Gold"]').data('image');
      let roseGold = $(this).find('.color-swatch[data-value="RoseGold"]').data('image');
      let previewImages = [silver, gold, roseGold];
      let previewImage = previewImages[counter % 3];
      $(this).find('.product-item__bg').attr("data-image",previewImage);
      $(this).find('.product-item__bg').css({"background-image": "url(" + previewImage + ")"}) ;
      $(this).find('.product-item__bg__under').attr("data-image",previewImage);
      $(this).find('.product-item__bg__under').css({"background-image": "url(" + previewImage + ")"}) ;
      counter++;
    });
  }, 2500);
  
  // Custom Color
  $('.color-swatch').each(function(){
    let color = $(this).data('value');
    if(color == 'RoseGold'){
      $(this).css('background', '#f8ccc0');
      $(this).attr('data-color', '#f8ccc0');
    }
  });
  
  // Hover Effect
  $('.color-swatch').click(function(){
    let img = $(this).data('image');
      $(this).closest(".product-item").find('.product-item__bg').attr("data-image",img);
      $(this).closest(".product-item").find('.product-item__bg').css({"background-image": "url(" + img + ")"}) ;
      $(this).closest(".product-item").find('.product-item__bg__under').attr("data-image",img);
      $(this).closest(".product-item").find('.product-item__bg__under').css({"background-image": "url(" + img + ")"}) ;
    console.log('Image Url ..', img);
  });
});*/

/*$(document).ready(function () {
  console.log('Ready....!');
  // Custom Color
  $('.color-swatch').each(function(){
    let color = $(this).data('value');
    if(color == 'RoseGold'){
      $(this).css('background', '#f8ccc0');
      $(this).attr('data-color', '#f8ccc0');
    //  console.log('Color Done', color);
    }
    // console.log('Color >> ', color);
  });
  // Hover Effect
  $('.color-swatch').click(function(){
    let img = $(this).data('image');
      $(this).closest(".product-item").find('.product-item__bg').attr("data-image",img);
      $(this).closest(".product-item").find('.product-item__bg').css({"background-image": "url(" + img + ")"}) ;
      $(this).closest(".product-item").find('.product-item__bg__under').attr("data-image",img);
      $(this).closest(".product-item").find('.product-item__bg__under').css({"background-image": "url(" + img + ")"}) ;

    console.log('Image Url ..', img);
  });
  
});*/
/*$(document).ready(function () {
  console.log('Ready....!');
  // Custom Color
  $('.color-swatch').each(function(){
    let color = $(this).data('value');
    if(color == 'RoseGold'){
      $(this).css('background', '#f8ccc0');
      $(this).attr('data-color', '#f8ccc0');
    }
  });
  
  // Apply Preview Images by Default
  let counter = 0;
  $('.product-item').each(function(){
    let silver = $(this).find('.color-swatch[data-value="Silver"]').data('image');
    let gold = $(this).find('.color-swatch[data-value="Gold"]').data('image');
    let roseGold = $(this).find('.color-swatch[data-value="RoseGold"]').data('image');
    let previewImages = [silver, gold, roseGold];
    let previewImage = previewImages[counter % 3];
    $(this).find('.product-item__bg').attr("data-image",previewImage);
    $(this).find('.product-item__bg').css({"background-image": "url(" + previewImage + ")"}) ;
    $(this).find('.product-item__bg__under').attr("data-image",previewImage);
    $(this).find('.product-item__bg__under').css({"background-image": "url(" + previewImage + ")"}) ;
    counter++;
  });
  
  // Hover Effect
  $('.color-swatch').click(function(){
    let img = $(this).data('image');
      $(this).closest(".product-item").find('.product-item__bg').attr("data-image",img);
      $(this).closest(".product-item").find('.product-item__bg').css({"background-image": "url(" + img + ")"}) ;
      $(this).closest(".product-item").find('.product-item__bg__under').attr("data-image",img);
      $(this).closest(".product-item").find('.product-item__bg__under').css({"background-image": "url(" + img + ")"}) ;
    console.log('Image Url ..', img);
  });
});*/
